<template>
 <!-- <div>
      <div class="chartBox" style="width:100%;height:294px;"  id="echarts" ref="echarts"></div>
    </div> -->
   <div class="charttest"> 
     <div style="width: 100%; height: 294px" id="echarts" ref="echarts"></div> -->
    <!-- chartBox -->
   </div>
</template>
<script>
  import echarts from 'echarts'
  import { mapActions } from "vuex";
    import {EleResize} from '@/assets/js/mapFormat.js'


  export default {
    name:'LineChart',
    data() {
      return {
      dataAxis: [],
      myChart1: "",
      data2: {
        apply: [],
        total: [],
      },
      };
    },
      created() {
        this.initChartsChart()
      },
       mounted() {
    //   this.drawCharts();
      this.$nextTick(() => {
      setTimeout(() => {
        this.drawCharts();
      
      },1000);
    });
    },
    methods: {
         ...mapActions("category", [
        "getChartData",
    ]),
          
    //     let  listener=function(){
    //   myChart1.resize();
    //  };
    //   EleResize.on(document.getElementById('echarts'),listener);
      beforeDestroy() {
      /* 页面组件销毁的时候，别忘了移除绑定的监听resize事件，否则的话，多渲染几次
      容易导致内存泄漏和额外CPU或GPU占用哦*/
      window.removeEventListener("resize", () => {
        this.myChart.resize();
      });
    },
    
        
    //共用一个组件的接口
    initChartsChart() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "pa_application_grant_trend",
          //园区专利申请/授权趋势
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.chartsdata = res.message.data;
          //数组去重
          let echararrlist = [];
          for (var i = 0; i < _this.chartsdata.length; i++) {
            var arrindex = echararrlist.findIndex((item, index, arr) => {
              return item.year === _this.chartsdata[i].year;
            }); //获取下标
            if (arrindex == -1) {
              //
              echararrlist.push({
                year: _this.chartsdata[i].year,
                num_application: [_this.chartsdata[i].num_application],
                num_grant: [_this.chartsdata[i].num_grant],
              });
            } else {
              echararrlist[arrindex].num_application.push(
                _this.chartsdata[i].num_application
              );
              echararrlist[arrindex].num_grant.push(
                _this.chartsdata[i].num_grant
              );
            }
            let numApplication = [];
            let numGrant = [];
            let yearCharts = [];
            echararrlist.forEach((item) => {
              let year = item.year;
              let num_application = item.num_application;
              let num_grant = item.num_grant;
              let sumnApplication = 0;
              let sumnGrant = 0;
              for (var i in num_application) {
                sumnApplication += num_application[i];
              }
              numApplication = numApplication.concat(sumnApplication);
              for (var K in num_grant) {
                sumnGrant += num_grant[K];
              }
              numGrant = numGrant.concat(sumnGrant);
              yearCharts = yearCharts.concat(year);
            });
            _this.dataAxis = yearCharts;
            _this.data2.apply = numApplication; //授权趋势
            _this.data2.total = numGrant; //申请趋势
          }
        },
      });
       

    },

 initChart() {
        this. myChart = echarts.init(document.getElementById(this.echarts));

      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },

      drawCharts() {
        var myChart = echarts.init(document.getElementById(this.echarts));
        myChart.setOption({
          tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: true,
        },
        grid: {
          left: "0",
          right: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.dataAxis,
          axisLabel: {
            color: "#777C8B",
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        color: [
          "#5AC6A8",
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "#C2C2C2", //深灰
              width: 1,
            },
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        series: [
          {
            name: "申请趋势",
            data: this.data2.apply,
            type: "line",
            smooth: true,
          },
          {
            name: "授权趋势",
            data: this.data2.total,
            type: "line",
            smooth: true,
          },
        ],
        });
    //         //   this.myChart1.setOption(option);
          this.myChart1.setOption(Option);
            let listener=function(){
              this.myChart1.resize();
            };
            EleResize.on(document.getElementById('echarts'),listener)

      }
      

      
    },
    computed: {
      echarts() {
        return 'echarts' + Math.random() * 100000;
      }
    },
   
    destroyed() {
      window.removeEventListener("resize", this.initChart, 20);
  },
    components: {}
  };
</script>

<style>
#echart {
  width: 100%;
  height: 600px;
}
</style>